import { dataTrendReportSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendReportSolid = /*#__PURE__*/createIcon(dataTrendReportSolid)
export default IconTrendReportSolid
